import { useContext, useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Avatar, Dropdown, Flex, Layout, Badge } from 'antd';
import { LogoutOutlined, UserOutlined, BellFilled } from '@ant-design/icons';
import { Footer, Header } from 'antd/es/layout/layout';
import { DashboardMenu } from '../dashboardMenu';
import { GlobalContext } from '../../utils/globalContext';
import { NOTIFICATION_BELL_COLOR, sessionStorageKey_menuRoutes, sessionStorageKey_session } from '../../utils/constants';
import '../../styles/dashboard.css';
import { NotificationModal } from '../common';

const LayoutDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setMenuKeys, user } = useContext(GlobalContext);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [invoiceErrors, setInvoiceErrors] = useState([]);
  const [hasAutoOpened, setHasAutoOpened] = useState(false);

  const handleErrorsFetched = (errors) => {
    setInvoiceErrors(errors);
    if (location.pathname === '/' && errors.length > 0 && !hasAutoOpened) {
      setIsModalVisible(true);
      setHasAutoOpened(true);
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem(sessionStorageKey_session);
    sessionStorage.removeItem(sessionStorageKey_menuRoutes);
    navigate(user.isAdmin ? '/admin_login' : '/login');
  };

  const getCurrentYear = () => new Date().getFullYear();

  const items = user.isAdmin
    ? [
      {
        key: '2',
        label: 'Cerrar sesión',

        icon: <LogoutOutlined />
      }
    ]
    : [
      {
        key: '1',
        label: 'Mi perfil',

        icon: <UserOutlined />
      },
      {
        key: '2',
        label: 'Cerrar sesión',

        icon: <LogoutOutlined />
      }
    ];

  const ACTIONS = {
    1: () => navigate('/profile'),
    2: () => handleLogout()
  };
  const onClickItem = ({ key }) => {
    ACTIONS[key]();
  };

  useEffect(() => {
    setHasAutoOpened(false);
  }, [user, location.pathname]);

  return (
    <Layout>
      <Header className="dashboard-header">
        <Flex justify="space-between" align="center">
          <div
            role="button"
            tabIndex={0}
            className="dashboard-header-title"
            onClick={() => {
              navigate('/');
              setMenuKeys([]);
            }}
            onKeyDown={(e) => {
              if (['Enter', ' '].includes(e.key)) {
                navigate('/');
                setMenuKeys([]);
              }
            }}>
            <Flex align="center" justify="center" vertical className='dashboard-header-logo'>
              <img alt="logo" src={`${process.env.PUBLIC_URL}/logoBdi.jpg`} width={80} height={40} />
              <div className="dashboard-header-title-text">Facturación</div>
            </Flex>
          </div>
          <DashboardMenu />
          <Flex align="center" gap={16}>
            {!user.isAdmin && <Badge count={invoiceErrors.length} overflowCount={99}>
              <BellFilled
                style={{ fontSize: '20px', cursor: 'pointer', color: NOTIFICATION_BELL_COLOR }}
                onClick={() => setIsModalVisible(true)}
              />
            </Badge>}
            <Dropdown menu={{ items, onClick: onClickItem }} className="dashboard-header-logout-btn">
              <Flex size="large" justify="space-between" align="center" gap={10}>
                <div className="dashboard-header-username">
                  {user.isAdmin
                    ? `${user?.user_nombre_str || ''} ${user?.user_apellido1_str || ''}`
                    : `${user?.clie_nombre || ''}  ${user?.clie_ap || ''}`}
                </div>
                <Avatar style={{ backgroundColor: '#d3d3d3' }} size="large" icon={<UserOutlined />} />
              </Flex>
            </Dropdown>
          </Flex>
        </Flex>
      </Header>

      <Layout className="dashboard-content">
        <Outlet />
      </Layout>

      <Footer className="dashboard-footer">BDI Facturación - {getCurrentYear()}</Footer>

      <NotificationModal
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        onErrorsFetched={handleErrorsFetched}
      />
    </Layout>
  );
};

export default LayoutDashboard;
